import React from 'react';
import { Rating } from '@mui/material';

/**
 * Proportional 5-star display (e.g. 4.8 → partial fill on the 5th star).
 * Uses MUI Rating — same approach as CustomerReviews — for reliable decimal fill.
 */
export default function FractionalStarRating({
  rating,
  filledColor = '#f5b301',
  emptyColor = '#d4d8e0',
  iconSize = '14px',
  maxStars = 5,
}) {
  const numericRating = Number(rating);
  if (Number.isNaN(numericRating)) {
    return null;
  }

  const value = Math.max(0, Math.min(maxStars, numericRating));

  return (
    <Rating
      value={value}
      precision={0.1}
      readOnly
      max={maxStars}
      sx={{
        fontSize: iconSize,
        lineHeight: 1,
        verticalAlign: 'middle',
        gap: '1px',
        '& .MuiRating-iconFilled': {
          color: filledColor,
        },
        '& .MuiRating-iconHover': {
          color: filledColor,
        },
        '& .MuiRating-iconEmpty': {
          color: emptyColor,
        },
      }}
    />
  );
}
